var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgCerkizborPop(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Warstwa_1",
    xmlns: "http://www.w3.org/2000/svg",
    width: 256,
    height: 110,
    viewBox: "0 0 256 110",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "cerkizab"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 161.34,
    y: 64.85,
    width: 52.6,
    height: 37.28,
    fill: "none",
    stroke: "#079acf",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.51
  }), /*#__PURE__*/React.createElement("rect", {
    x: 141.43,
    y: 38.13,
    width: 13.28,
    height: 59.06,
    fill: "none",
    stroke: "#079acf",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.51
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "138.02 37.28 141.43 38.13 141.43 97.19 138.02 93.79 138.02 37.28",
    fill: "none",
    stroke: "#079acf",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.51
  }), /*#__PURE__*/React.createElement("polyline", {
    points: "155.21 46.13 206.45 46.13 218.36 64.85 161.34 64.85 155.21 53.96 155.38 97.02 161.34 102.13",
    fill: "none",
    stroke: "#079acf",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.51
  }), /*#__PURE__*/React.createElement("rect", {
    x: 194.36,
    y: 42.48,
    width: 5.11,
    height: 6.58,
    fill: "none",
    stroke: "#079acf",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.37
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "141.43 38.13 158.11 38.13 153.85 32.85 144.32 32.85 141.43 38.13",
    fill: "none",
    stroke: "#079acf",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.51
  }), /*#__PURE__*/React.createElement("path", {
    d: "M141.43,38.13l-4.94-1.36,3.06-4.94,4.77,1.02c-1.93-5.92-1.13-12.5,2.38-19.74,7.89,6.22,11.48,12.72,7.15,19.74",
    fill: "none",
    stroke: "#079acf",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.51
  }), /*#__PURE__*/React.createElement("path", {
    d: "M146.7,13.11c-7.32,5.79-12.09,12.26-7.15,18.72",
    fill: "none",
    stroke: "#079acf",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.51
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "194.36 49.06 191.89 46.72 191.89 41.15 194.36 42.48 194.36 49.06",
    fill: "none",
    stroke: "#079acf",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.37
  }), /*#__PURE__*/React.createElement("polyline", {
    points: "199.47 42.77 200.57 42.77 199.3 40.26 194.96 40.26 194.36 42.77",
    fill: "none",
    stroke: "#079acf",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.51
  }), /*#__PURE__*/React.createElement("polyline", {
    points: "191.89 41.15 191.38 40.51 192.66 39.11 194.96 40.26",
    fill: "none",
    stroke: "#079acf",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.51
  }), /*#__PURE__*/React.createElement("path", {
    d: "M199.3,40.26c.64-2.65-.15-4.74-2.43-6.26-1.62,2.05-2.04,4-1.4,5.87",
    fill: "none",
    stroke: "#079acf",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.51
  }), /*#__PURE__*/React.createElement("path", {
    d: "M192.66,39.11c-.29-3.69,1.89-4.48,4.21-5.11",
    fill: "none",
    stroke: "#079acf",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.51
  }), /*#__PURE__*/React.createElement("line", {
    x1: 196.74,
    y1: 33.7,
    x2: 196.74,
    y2: 29.7,
    fill: "none",
    stroke: "#079acf",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.51
  }), /*#__PURE__*/React.createElement("line", {
    x1: 195.64,
    y1: 30.64,
    x2: 197.77,
    y2: 30.64,
    fill: "none",
    stroke: "#079acf",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.51
  }), /*#__PURE__*/React.createElement("line", {
    x1: 146.7,
    y1: 13.28,
    x2: 146.7,
    y2: 4,
    fill: "none",
    stroke: "#079acf",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.51
  }), /*#__PURE__*/React.createElement("line", {
    x1: 144.49,
    y1: 7.57,
    x2: 149.43,
    y2: 7.57,
    fill: "none",
    stroke: "#079acf",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.51
  }), /*#__PURE__*/React.createElement("rect", {
    x: 171.34,
    y: 72.04,
    width: 8.55,
    height: 16.6,
    fill: "none",
    stroke: "#079acf",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.51
  }), /*#__PURE__*/React.createElement("rect", {
    x: 186.28,
    y: 72.04,
    width: 8.55,
    height: 16.6,
    fill: "none",
    stroke: "#079acf",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.51
  }), /*#__PURE__*/React.createElement("rect", {
    x: 201.21,
    y: 72.04,
    width: 8.55,
    height: 16.6,
    fill: "none",
    stroke: "#079acf",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.51
  }), /*#__PURE__*/React.createElement("line", {
    x1: 171.09,
    y1: 65.15,
    x2: 171.09,
    y2: 102.04,
    fill: "none",
    stroke: "#079acf",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 180.02,
    y1: 65.15,
    x2: 180.02,
    y2: 102.04,
    fill: "none",
    stroke: "#079acf",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 186.02,
    y1: 65.15,
    x2: 186.02,
    y2: 102.04,
    fill: "none",
    stroke: "#079acf",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 195.21,
    y1: 65.15,
    x2: 195.21,
    y2: 102.04,
    fill: "none",
    stroke: "#079acf",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 201.09,
    y1: 65.15,
    x2: 201.09,
    y2: 102.04,
    fill: "none",
    stroke: "#079acf",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 210.15,
    y1: 65.15,
    x2: 210.15,
    y2: 102.04,
    fill: "none",
    stroke: "#079acf",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("polyline", {
    points: "213.98 71.66 161.77 71.66 155.51 67.83 141.72 67.83 138.53 65.66",
    fill: "none",
    stroke: "#079acf",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("polyline", {
    points: "213.98 89.15 161.77 89.15 155.77 85.45 141.6 85.45",
    fill: "none",
    stroke: "#079acf",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M159.36,70.35h0c-1.23-.77-2.83.12-2.83,1.57v13.4l3.7,2.3v-15.69c0-.64-.33-1.24-.87-1.57Z",
    fill: "none",
    stroke: "#079acf",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("polyline", {
    points: "155.38 70.51 142.11 70.51 138.66 68.21",
    fill: "none",
    stroke: "#079acf",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 138.15,
    y1: 84.3,
    x2: 118.11,
    y2: 84.3,
    fill: "none",
    stroke: "#079acf",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 214.11,
    y1: 84.68,
    x2: 227,
    y2: 84.68,
    fill: "none",
    stroke: "#079acf",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 32.83,
    y1: 85.11,
    x2: 13.43,
    y2: 85.11,
    fill: "none",
    stroke: "#079acf",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("g", {
    id: "cerkiew_slupnika"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M32.47,50.62c-5.88-1.59-3.56-3.76,7.26-6.52,1.8-.46,3.57-1.01,5.31-1.64l13.52-4.93",
    fill: "none",
    stroke: "#e77500",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.38
  }), /*#__PURE__*/React.createElement("polyline", {
    points: "58.85 37.33 73.3 39.93 73.3 36.66 87.83 24.72 101.12 41.57 101.12 44.17 111.52 45.9",
    fill: "none",
    stroke: "#e77500",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.38
  }), /*#__PURE__*/React.createElement("polyline", {
    points: "79.75 91.73 62.99 77.39 48.94 77.39",
    fill: "none",
    stroke: "#e77500",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.38
  }), /*#__PURE__*/React.createElement("polyline", {
    points: "127.12 90.58 109.21 78.73 94.09 78.73",
    fill: "none",
    stroke: "#e77500",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.38
  }), /*#__PURE__*/React.createElement("line", {
    x1: 71.85,
    y1: 45.23,
    x2: 71.85,
    y2: 84.32,
    fill: "none",
    stroke: "#e77500",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2.51
  }), /*#__PURE__*/React.createElement("polyline", {
    points: "69.25 45.23 71.37 44.65 74.35 44.94",
    fill: "none",
    stroke: "#e77500",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.38
  }), /*#__PURE__*/React.createElement("polyline", {
    points: "69.25 41.76 71.37 41.18 74.35 41.47",
    fill: "none",
    stroke: "#e77500",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.38
  }), /*#__PURE__*/React.createElement("line", {
    x1: 69.35,
    y1: 45.03,
    x2: 69.35,
    y2: 42.05,
    fill: "none",
    stroke: "#e77500",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("line", {
    x1: 74.35,
    y1: 44.94,
    x2: 74.35,
    y2: 41.57,
    fill: "none",
    stroke: "#e77500",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("line", {
    x1: 71.27,
    y1: 44.75,
    x2: 71.27,
    y2: 41.66,
    fill: "none",
    stroke: "#e77500",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("line", {
    x1: 93.03,
    y1: 53.7,
    x2: 93.03,
    y2: 85.76,
    fill: "none",
    stroke: "#e77500",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2.51
  }), /*#__PURE__*/React.createElement("polyline", {
    points: "90.43 53.7 92.55 53.12 95.54 53.41",
    fill: "none",
    stroke: "#e77500",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.38
  }), /*#__PURE__*/React.createElement("polyline", {
    points: "90.43 50.23 92.55 49.66 95.54 49.95",
    fill: "none",
    stroke: "#e77500",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.38
  }), /*#__PURE__*/React.createElement("line", {
    x1: 90.53,
    y1: 53.51,
    x2: 90.53,
    y2: 50.52,
    fill: "none",
    stroke: "#e77500",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("line", {
    x1: 95.54,
    y1: 53.41,
    x2: 95.54,
    y2: 50.04,
    fill: "none",
    stroke: "#e77500",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("line", {
    x1: 92.46,
    y1: 53.22,
    x2: 92.46,
    y2: 50.14,
    fill: "none",
    stroke: "#e77500",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("line", {
    x1: 98.91,
    y1: 49.17,
    x2: 98.91,
    y2: 85.96,
    fill: "none",
    stroke: "#e77500",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2.51
  }), /*#__PURE__*/React.createElement("polyline", {
    points: "96.31 49.17 98.43 48.6 101.41 48.89",
    fill: "none",
    stroke: "#e77500",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.38
  }), /*#__PURE__*/React.createElement("polyline", {
    points: "96.31 45.71 98.43 45.13 101.41 45.42",
    fill: "none",
    stroke: "#e77500",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.38
  }), /*#__PURE__*/React.createElement("line", {
    x1: 96.4,
    y1: 48.98,
    x2: 96.4,
    y2: 46,
    fill: "none",
    stroke: "#e77500",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("line", {
    x1: 101.41,
    y1: 48.89,
    x2: 101.41,
    y2: 45.52,
    fill: "none",
    stroke: "#e77500",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("line", {
    x1: 98.33,
    y1: 48.69,
    x2: 98.33,
    y2: 45.61,
    fill: "none",
    stroke: "#e77500",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("line", {
    x1: 107,
    y1: 50.62,
    x2: 107,
    y2: 85.86,
    fill: "none",
    stroke: "#e77500",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2.51
  }), /*#__PURE__*/React.createElement("polyline", {
    points: "104.4 50.62 106.51 50.04 109.5 50.33",
    fill: "none",
    stroke: "#e77500",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.38
  }), /*#__PURE__*/React.createElement("polyline", {
    points: "104.4 47.15 106.51 46.58 109.5 46.86",
    fill: "none",
    stroke: "#e77500",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.38
  }), /*#__PURE__*/React.createElement("line", {
    x1: 104.49,
    y1: 50.43,
    x2: 104.49,
    y2: 47.44,
    fill: "none",
    stroke: "#e77500",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("line", {
    x1: 109.5,
    y1: 50.33,
    x2: 109.5,
    y2: 46.96,
    fill: "none",
    stroke: "#e77500",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("line", {
    x1: 106.42,
    y1: 50.14,
    x2: 106.42,
    y2: 47.06,
    fill: "none",
    stroke: "#e77500",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("line", {
    x1: 60.1,
    y1: 43.78,
    x2: 60.1,
    y2: 86.73,
    fill: "none",
    stroke: "#e77500",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2.51
  }), /*#__PURE__*/React.createElement("polyline", {
    points: "57.5 43.78 59.62 43.21 62.61 43.49",
    fill: "none",
    stroke: "#e77500",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.38
  }), /*#__PURE__*/React.createElement("polyline", {
    points: "57.5 40.32 59.62 39.74 62.61 40.03",
    fill: "none",
    stroke: "#e77500",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.38
  }), /*#__PURE__*/React.createElement("line", {
    x1: 57.6,
    y1: 43.59,
    x2: 57.6,
    y2: 40.61,
    fill: "none",
    stroke: "#e77500",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("line", {
    x1: 62.61,
    y1: 43.49,
    x2: 62.61,
    y2: 40.12,
    fill: "none",
    stroke: "#e77500",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("line", {
    x1: 59.53,
    y1: 43.3,
    x2: 59.53,
    y2: 40.22,
    fill: "none",
    stroke: "#e77500",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("line", {
    x1: 48.07,
    y1: 47.54,
    x2: 48.07,
    y2: 86.15,
    fill: "none",
    stroke: "#e77500",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2.51
  }), /*#__PURE__*/React.createElement("polyline", {
    points: "45.47 47.54 47.59 46.96 50.57 47.25",
    fill: "none",
    stroke: "#e77500",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.38
  }), /*#__PURE__*/React.createElement("polyline", {
    points: "45.47 44.07 47.59 43.49 50.57 43.78",
    fill: "none",
    stroke: "#e77500",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.38
  }), /*#__PURE__*/React.createElement("line", {
    x1: 45.57,
    y1: 47.35,
    x2: 45.57,
    y2: 44.36,
    fill: "none",
    stroke: "#e77500",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("line", {
    x1: 50.57,
    y1: 47.25,
    x2: 50.57,
    y2: 43.88,
    fill: "none",
    stroke: "#e77500",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("line", {
    x1: 47.49,
    y1: 47.06,
    x2: 47.49,
    y2: 43.98,
    fill: "none",
    stroke: "#e77500",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("line", {
    x1: 46.05,
    y1: 87.59,
    x2: 49.61,
    y2: 87.59,
    fill: "none",
    stroke: "#e77500",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2.51
  }), /*#__PURE__*/React.createElement("line", {
    x1: 57.41,
    y1: 88.27,
    x2: 60.1,
    y2: 88.27,
    fill: "none",
    stroke: "#e77500",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2.51
  }), /*#__PURE__*/React.createElement("line", {
    x1: 91.2,
    y1: 86.24,
    x2: 94.48,
    y2: 86.24,
    fill: "none",
    stroke: "#e77500",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.89
  }), /*#__PURE__*/React.createElement("line", {
    x1: 97.17,
    y1: 86.24,
    x2: 100.45,
    y2: 86.24,
    fill: "none",
    stroke: "#e77500",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.89
  }), /*#__PURE__*/React.createElement("line", {
    x1: 105.07,
    y1: 86.24,
    x2: 108.34,
    y2: 86.24,
    fill: "none",
    stroke: "#e77500",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.89
  }), /*#__PURE__*/React.createElement("polyline", {
    points: "64.34 37.62 74.84 29.05 87.83 24.72",
    fill: "none",
    stroke: "#e77500",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.51
  }), /*#__PURE__*/React.createElement("path", {
    d: "M33.05,45.61c1.9-9.05,4.7-17.85,22.53-22.72,1.97-1.16,3.81-2.5,5.2-4.43,1.7,2.05,3.48,3.81,5.49,4.72,3.84,1.05,7.25,2.82,10.3,5.2",
    fill: "none",
    stroke: "#e77500",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.51
  }), /*#__PURE__*/React.createElement("path", {
    d: "M48.07,80.47l16.75.39,15.89,13.77-.19,8.09-3.27.39-44.58-5.39v-48.62c1.54-1.49,4.05-2.71,7.91-3.57,1.44-.32,2.92-.47,4.4-.47h.3",
    fill: "none",
    stroke: "#e77500",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.51
  }), /*#__PURE__*/React.createElement("polyline", {
    points: "32.66 88.46 60.68 89.71 60.68 81.14",
    fill: "none",
    stroke: "#e77500",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.51
  }), /*#__PURE__*/React.createElement("polyline", {
    points: "77.24 103.09 77.44 95.39 61.55 80.95",
    fill: "none",
    stroke: "#e77500",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.51
  }), /*#__PURE__*/React.createElement("line", {
    x1: 80.71,
    y1: 94.62,
    x2: 77.44,
    y2: 95.39,
    fill: "none",
    stroke: "#e77500",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 0.63
  }), /*#__PURE__*/React.createElement("line", {
    x1: 60.39,
    y1: 100.88,
    x2: 60.39,
    y2: 89.71,
    fill: "none",
    stroke: "#e77500",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.51
  }), /*#__PURE__*/React.createElement("line", {
    x1: 68.29,
    y1: 81.91,
    x2: 68.29,
    y2: 85.28,
    fill: "none",
    stroke: "#e77500",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 0.63
  }), /*#__PURE__*/React.createElement("line", {
    x1: 73.49,
    y1: 86.82,
    x2: 73.49,
    y2: 89.61,
    fill: "none",
    stroke: "#e77500",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 0.63
  }), /*#__PURE__*/React.createElement("line", {
    x1: 78.59,
    y1: 90.96,
    x2: 78.59,
    y2: 93.85,
    fill: "none",
    stroke: "#e77500",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 0.63
  }), /*#__PURE__*/React.createElement("line", {
    x1: 63.38,
    y1: 77.77,
    x2: 63.38,
    y2: 81.43,
    fill: "none",
    stroke: "#e77500",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 0.63
  }), /*#__PURE__*/React.createElement("line", {
    x1: 54.23,
    y1: 77.58,
    x2: 54.23,
    y2: 80.47,
    fill: "none",
    stroke: "#e77500",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 0.63
  }), /*#__PURE__*/React.createElement("line", {
    x1: 50.48,
    y1: 77.58,
    x2: 50.48,
    y2: 80.47,
    fill: "none",
    stroke: "#e77500",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 0.63
  }), /*#__PURE__*/React.createElement("polyline", {
    points: "93.52 81.33 107.57 81.33 126.45 92.98 126.45 100.69 128.66 100.3 128.56 92.98 110.08 81.33 107.57 81.33",
    fill: "none",
    stroke: "#e77500",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.51
  }), /*#__PURE__*/React.createElement("polyline", {
    points: "88.03 87.11 88.03 49.46 55.58 45.13 51.05 45.32",
    fill: "none",
    stroke: "#e77500",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.51
  }), /*#__PURE__*/React.createElement("line", {
    x1: 104.4,
    y1: 47.92,
    x2: 101.8,
    y2: 48.69,
    fill: "none",
    stroke: "#e77500",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 0.63
  }), /*#__PURE__*/React.createElement("line", {
    x1: 88.03,
    y1: 52.26,
    x2: 90.34,
    y2: 51.29,
    fill: "none",
    stroke: "#e77500",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 0.63
  }), /*#__PURE__*/React.createElement("line", {
    x1: 75.99,
    y1: 87.59,
    x2: 110.08,
    y2: 87.59,
    fill: "none",
    stroke: "#e77500",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 0.63
  }), /*#__PURE__*/React.createElement("line", {
    x1: 77.53,
    y1: 89.13,
    x2: 111.71,
    y2: 89.13,
    fill: "none",
    stroke: "#e77500",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 0.63
  }), /*#__PURE__*/React.createElement("line", {
    x1: 77.53,
    y1: 90.58,
    x2: 113.83,
    y2: 90.58,
    fill: "none",
    stroke: "#e77500",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 0.63
  }), /*#__PURE__*/React.createElement("line", {
    x1: 77.53,
    y1: 92.02,
    x2: 116.05,
    y2: 92.02,
    fill: "none",
    stroke: "#e77500",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 0.63
  }), /*#__PURE__*/React.createElement("line", {
    x1: 79.55,
    y1: 93.47,
    x2: 117.88,
    y2: 93.47,
    fill: "none",
    stroke: "#e77500",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 0.63
  }), /*#__PURE__*/React.createElement("line", {
    x1: 77.53,
    y1: 94.91,
    x2: 119.71,
    y2: 94.91,
    fill: "none",
    stroke: "#e77500",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 0.63
  }), /*#__PURE__*/React.createElement("line", {
    x1: 80.81,
    y1: 96.35,
    x2: 121.63,
    y2: 96.35,
    fill: "none",
    stroke: "#e77500",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 0.63
  }), /*#__PURE__*/React.createElement("line", {
    x1: 80.71,
    y1: 97.8,
    x2: 123.46,
    y2: 97.8,
    fill: "none",
    stroke: "#e77500",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 0.63
  }), /*#__PURE__*/React.createElement("line", {
    x1: 80.52,
    y1: 99.24,
    x2: 125.67,
    y2: 99.24,
    fill: "none",
    stroke: "#e77500",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 0.63
  }), /*#__PURE__*/React.createElement("line", {
    x1: 80.61,
    y1: 100.69,
    x2: 126.45,
    y2: 100.69,
    fill: "none",
    stroke: "#e77500",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 0.63
  }), /*#__PURE__*/React.createElement("line", {
    x1: 73.58,
    y1: 40.41,
    x2: 100.74,
    y2: 44.75,
    fill: "none",
    stroke: "#e77500",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.51
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "75.7 38.29 98.71 42.24 86.87 27.99 75.7 38.29",
    fill: "none",
    stroke: "#e77500",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.51
  }), /*#__PURE__*/React.createElement("polyline", {
    points: "60.68 53.22 83.12 55.53 83.12 87.3",
    fill: "none",
    stroke: "#e77500",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.51
  }), /*#__PURE__*/React.createElement("path", {
    d: "M62.32,16.68c0-.88-1.59-1.59-1.59-1.59,0,0-1.59.71-1.59,1.59s.71,1.59,1.59,1.59,1.59-.71,1.59-1.59Z",
    fill: "none",
    stroke: "#e77500",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 0.63
  }), /*#__PURE__*/React.createElement("path", {
    d: "M87.45,22.99c0-.66-1.2-1.2-1.2-1.2,0,0-1.2.54-1.2,1.2s.54,1.2,1.2,1.2,1.2-.54,1.2-1.2Z",
    fill: "none",
    stroke: "#e77500",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 0.48
  }), /*#__PURE__*/React.createElement("line", {
    x1: 60.73,
    y1: 15.09,
    x2: 60.73,
    y2: 6.91,
    fill: "none",
    stroke: "#e77500",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 0.48
  }), /*#__PURE__*/React.createElement("line", {
    x1: 58.37,
    y1: 9.31,
    x2: 63.09,
    y2: 9.31,
    fill: "none",
    stroke: "#e77500",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 0.48
  }), /*#__PURE__*/React.createElement("line", {
    x1: 59.82,
    y1: 7.68,
    x2: 61.93,
    y2: 7.68,
    fill: "none",
    stroke: "#e77500",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 0.48
  }), /*#__PURE__*/React.createElement("line", {
    x1: 59.72,
    y1: 12.01,
    x2: 62.03,
    y2: 13.65,
    fill: "none",
    stroke: "#e77500",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 0.48
  }), /*#__PURE__*/React.createElement("line", {
    x1: 86.25,
    y1: 21.78,
    x2: 86.25,
    y2: 14.99,
    fill: "none",
    stroke: "#e77500",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 0.48
  }), /*#__PURE__*/React.createElement("line", {
    x1: 84.66,
    y1: 16.73,
    x2: 87.74,
    y2: 17.3,
    fill: "none",
    stroke: "#e77500",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 0.48
  }), /*#__PURE__*/React.createElement("line", {
    x1: 85.33,
    y1: 18.65,
    x2: 87.16,
    y2: 20.48,
    fill: "none",
    stroke: "#e77500",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 0.48
  })), /*#__PURE__*/React.createElement("line", {
    x1: 174.09,
    y1: 72.17,
    x2: 174.09,
    y2: 88.34,
    fill: "none",
    stroke: "#079acf",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 0.75
  }), /*#__PURE__*/React.createElement("line", {
    x1: 176.98,
    y1: 72.17,
    x2: 176.98,
    y2: 88.34,
    fill: "none",
    stroke: "#079acf",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 0.75
  }), /*#__PURE__*/React.createElement("line", {
    x1: 171.47,
    y1: 74.55,
    x2: 179.89,
    y2: 74.55,
    fill: "none",
    stroke: "#079acf",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 0.75
  }), /*#__PURE__*/React.createElement("line", {
    x1: 171.47,
    y1: 76.85,
    x2: 179.89,
    y2: 76.85,
    fill: "none",
    stroke: "#079acf",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 0.75
  }), /*#__PURE__*/React.createElement("line", {
    x1: 171.47,
    y1: 79.15,
    x2: 179.89,
    y2: 79.15,
    fill: "none",
    stroke: "#079acf",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 0.75
  }), /*#__PURE__*/React.createElement("line", {
    x1: 171.47,
    y1: 81.45,
    x2: 179.89,
    y2: 81.45,
    fill: "none",
    stroke: "#079acf",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 0.75
  }), /*#__PURE__*/React.createElement("line", {
    x1: 171.47,
    y1: 83.74,
    x2: 179.89,
    y2: 83.74,
    fill: "none",
    stroke: "#079acf",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 0.75
  }), /*#__PURE__*/React.createElement("line", {
    x1: 171.47,
    y1: 86.04,
    x2: 179.89,
    y2: 86.04,
    fill: "none",
    stroke: "#079acf",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 0.75
  }), /*#__PURE__*/React.createElement("line", {
    x1: 189.06,
    y1: 72.17,
    x2: 189.06,
    y2: 88.34,
    fill: "none",
    stroke: "#079acf",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 0.75
  }), /*#__PURE__*/React.createElement("line", {
    x1: 191.96,
    y1: 72.17,
    x2: 191.96,
    y2: 88.34,
    fill: "none",
    stroke: "#079acf",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 0.75
  }), /*#__PURE__*/React.createElement("line", {
    x1: 186.45,
    y1: 74.55,
    x2: 194.87,
    y2: 74.55,
    fill: "none",
    stroke: "#079acf",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 0.75
  }), /*#__PURE__*/React.createElement("line", {
    x1: 186.45,
    y1: 76.85,
    x2: 194.87,
    y2: 76.85,
    fill: "none",
    stroke: "#079acf",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 0.75
  }), /*#__PURE__*/React.createElement("line", {
    x1: 186.45,
    y1: 79.15,
    x2: 194.87,
    y2: 79.15,
    fill: "none",
    stroke: "#079acf",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 0.75
  }), /*#__PURE__*/React.createElement("line", {
    x1: 186.45,
    y1: 81.45,
    x2: 194.87,
    y2: 81.45,
    fill: "none",
    stroke: "#079acf",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 0.75
  }), /*#__PURE__*/React.createElement("line", {
    x1: 186.45,
    y1: 83.74,
    x2: 194.87,
    y2: 83.74,
    fill: "none",
    stroke: "#079acf",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 0.75
  }), /*#__PURE__*/React.createElement("line", {
    x1: 186.45,
    y1: 86.04,
    x2: 194.87,
    y2: 86.04,
    fill: "none",
    stroke: "#079acf",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 0.75
  }), /*#__PURE__*/React.createElement("line", {
    x1: 204.04,
    y1: 72.17,
    x2: 204.04,
    y2: 88.34,
    fill: "none",
    stroke: "#079acf",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 0.75
  }), /*#__PURE__*/React.createElement("line", {
    x1: 206.94,
    y1: 72.17,
    x2: 206.94,
    y2: 88.34,
    fill: "none",
    stroke: "#079acf",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 0.75
  }), /*#__PURE__*/React.createElement("line", {
    x1: 201.43,
    y1: 74.55,
    x2: 209.85,
    y2: 74.55,
    fill: "none",
    stroke: "#079acf",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 0.75
  }), /*#__PURE__*/React.createElement("line", {
    x1: 201.43,
    y1: 76.85,
    x2: 209.85,
    y2: 76.85,
    fill: "none",
    stroke: "#079acf",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 0.75
  }), /*#__PURE__*/React.createElement("line", {
    x1: 201.43,
    y1: 79.15,
    x2: 209.85,
    y2: 79.15,
    fill: "none",
    stroke: "#079acf",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 0.75
  }), /*#__PURE__*/React.createElement("line", {
    x1: 201.43,
    y1: 81.45,
    x2: 209.85,
    y2: 81.45,
    fill: "none",
    stroke: "#079acf",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 0.75
  }), /*#__PURE__*/React.createElement("line", {
    x1: 201.43,
    y1: 83.74,
    x2: 209.85,
    y2: 83.74,
    fill: "none",
    stroke: "#079acf",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 0.75
  }), /*#__PURE__*/React.createElement("line", {
    x1: 201.43,
    y1: 86.04,
    x2: 209.85,
    y2: 86.04,
    fill: "none",
    stroke: "#079acf",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 0.75
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCerkizborPop);
export default __webpack_public_path__ + "static/media/cerkizbor_pop.cd72098b4803a7411ad1faaf97d39f52.svg";
export { ForwardRef as ReactComponent };